import React, { useId } from "react";
import { clsx } from "clsx";

interface TextFieldProps extends React.ComponentPropsWithRef<"input"> {
  labelText: React.ReactNode;
  validationStatus?: "valid" | "invalid";
  validationMessage?: React.ReactNode;
  inputSize?: "small" | "large";
}

const TextInput = React.forwardRef<HTMLInputElement, TextFieldProps>(
  function TextInput(
    { labelText, inputSize, validationStatus, validationMessage, ...rest },
    ref
  ) {
    const inputId = useId();
    const errorId = useId();

    return (
      <div>
        <div
          className={clsx(
            "vst-text-field",
            inputSize === "small" && "vst-text-field-size-small",
            inputSize === "large" && "vst-text-field-size-large",
            validationStatus === "invalid" &&
              "vst-text-field-validation-invalid",
            validationStatus === "valid" && "vst-text-field-validation-valid"
          )}
        >
          <label htmlFor={inputId}>{labelText}</label>
          <input
            type="text"
            {...rest}
            ref={ref}
            id={inputId}
            aria-describedby={errorId}
            aria-invalid={validationStatus === "invalid"}
          />
        </div>
        {validationMessage && (
          <div
            className={clsx(
              "vst-validation-message",
              "vst-validation-message-size-small",
              validationStatus === "valid" &&
                "vst-validation-message-variant-valid"
            )}
            id={errorId}
            style={{ marginTop: 4 }}
          >
            {validationMessage}
          </div>
        )}
      </div>
    );
  }
);

export default TextInput;
